<script setup lang="ts">
    import { FormInputProps, FormInputData } from '~~/composables/useFormInput';

    const props = defineProps<FormInputProps>();
    const inputData: FormInputData = useFormInput(props);
    inputData.inlineLabel = true;
</script>

<template>
    <FormElement :input-data="inputData">
        <input
            :id="inputData.inputId.value"
            v-model="inputData.model.value"
            :name="inputData.props.inputName"
            class="nice-checkbox"
            type="checkbox"
        />
    </FormElement>
</template>
